export default "__VITE_ASSET__BTdPxXse__";